<template>
  <div>
    <div class="collect_history-list">
      <div v-for="(item, index) in childCategoryList" :key="'chile' + item.id" class="prod-list-item" @click="toGoods(index)">
        <div class="prod-list-item-img">
          <img :src="item.imageUrl" alt="" />
        </div>
        <div class="prod-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'category-goods',
    props:{
      childCategoryList: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data () {
      return {
      }
    },
    components:{
    },
    created(){
    },
    methods:{
      toGoods(index) {
        this.$router.push({
          name: 'retail-goods',
          query: {
            id: this.childCategoryList[index].id
          },
        });
      },
    }
  }
</script>

<style scoped>
.collect_history-list {
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 10px 5px;
}
.prod-list-item {
  width: 32%;
  height: 200px;
  text-align: center;
  margin-top: 10px;
}
.prod-list-item-img {
  background: rgba(0, 0, 0, 2%);
  width: 100%;
  height: calc(100% - 50px);
  border-radius: 16px;
  overflow: hidden;
}
.prod-list-item-img img {
  width: auto;
  height: 100%;
  max-width: 100%;
}
.prod-name {
  width: 90%;
  height: 40px;
  line-height: 40px;
  margin-top: 10px;
  font-size: 20px;
  color: #6A6A6A;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/retail/components/categoryGoods.vue